import { render, staticRenderFns } from "./competitor-filter.vue?vue&type=template&id=3aae3182&scoped=true"
import script from "./competitor-filter.vue?vue&type=script&lang=js"
export * from "./competitor-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae3182",
  null
  
)

export default component.exports